import { H3 } from 'components/texts'
import { Box, Paper } from '@mui/material'
import Container from '@mui/material/Container'
import React, { useContext, useEffect, useState } from 'react'
import { ListTableHeader } from 'pages/logged/admin/components'
import { EmpleadoListContext } from 'contexts/employee/ListContext'
import { Search as SearchIcon } from '@mui/icons-material'
import { Accordion, BreadcrumbsList, Datagrid } from 'components/data_display'
import SearchFormDatosColegio, { search } from 'components/forms/display/datos-colegio/SearchForm'
import { basicColumns, columnsAlumnosColegios, columnsGrupoColegio, columnsGrupoCL } from './columns.js'

const keyColumns = {
  "alumnos":        columnsAlumnosColegios,
  "colegios":       columnsAlumnosColegios,
  "grupos_colegio": columnsGrupoColegio,
  "grupos_cl":      columnsGrupoCL,
}

/**
 * Listado de los datos del colegio
 */
export default function ListadoDatosColegio() {
  const [data,         setData]         = useState({data: [], rowCount: 0})
  const [columns,      setColumns]      = useState(basicColumns.concat(columnsAlumnosColegios))
  const [loadingTable, setLoadingTable] = useState(false)
  const [params,       setParams]       = useState(null)

  const { update, resetContextState } = useContext(EmpleadoListContext)

  useEffect(() => {
    setLoadingTable(false)
  }, [data])

  useEffect(resetContextState, [])

  /**
   * Callback para actualizar la tabla una vez hecha la petición
   * 
   * @param {Array} data 
   * @param {Int}   rowCount 
   */
  const updateTable = (data, rowCount, page, params) => {
    setData({data, rowCount})
    update(rowCount, data, params, page)
    setParams(params)
  }
  
  const updateColumns = (_, keyColumn) => {
    setColumns(basicColumns.concat(keyColumns[keyColumn]))
  }

  return (
    <Container maxWidth={false} sx={{ mt: 5 }}>
      <BreadcrumbsList breadcrumbsList={[
        { to: "/",          label: "Inicio" },
        { to: "../alumnos", label: "Alumnos" },
        { to: "./",         label: "Datos en colegios", actualItem: true },
      ]} />

      <Accordion header={<Box display={"flex"} alignItems={"center"}><SearchIcon className={"mx-5"} /> <H3 className="my-0">Buscar datos en colegios</H3></Box>}>
        <SearchFormDatosColegio
          searchCallback      = {updateTable}
          onChangeSearchIndex = {updateColumns}
          onLoadingCallback   = {setLoadingTable} />
      </Accordion>

      <Paper elevation={2} sx={{mx: 8, my: 2, p: 5}}>
        <ListTableHeader rowCount={data.rowCount} params={params} keyValue={"datos-colegio"}/>

        <Datagrid
          rows         = {data.data}
          columns      = {columns}
          loading      = {loadingTable}
          rowCount     = {data.rowCount}
          onPageChange = {(page) => { search(page, () => setLoadingTable(true), updateTable) }}
          serverSide />
      </Paper>
    </Container>
  )
}
